import { Mesh, PlaneGeometry } from "three";
import { UVMapPlane } from "@rendering/vortex-core";
// Builds and UV maps the meshes seen on the front and sides of the canvas print
export function buildFrontCanvasMeshes(dimensions, innerUVCoords, outerUVCoords) {
  const meshes = [];
  const frontGeometry = new PlaneGeometry(dimensions.width, dimensions.height);
  UVMapPlane(frontGeometry, innerUVCoords[0], innerUVCoords[2], innerUVCoords[1], innerUVCoords[3]);
  const frontMesh = new Mesh(frontGeometry);
  frontMesh.uuid = "front";
  frontMesh.position.setZ(dimensions.depth / 2);
  meshes.push(frontMesh);
  const leftGeometry = new PlaneGeometry(dimensions.depth, dimensions.height);
  UVMapPlane(leftGeometry, outerUVCoords[0], innerUVCoords[0], innerUVCoords[1], innerUVCoords[3]);
  const leftMesh = new Mesh(leftGeometry);
  leftMesh.uuid = "left";
  leftMesh.rotateY(-Math.PI / 2);
  leftMesh.position.setX(-dimensions.width / 2);
  meshes.push(leftMesh);
  const rightGeometry = new PlaneGeometry(dimensions.depth, dimensions.height);
  UVMapPlane(rightGeometry, innerUVCoords[2], outerUVCoords[2], innerUVCoords[1], innerUVCoords[3]);
  const rightMesh = new Mesh(rightGeometry);
  rightMesh.uuid = "right";
  rightMesh.rotateY(Math.PI / 2);
  rightMesh.position.setX(dimensions.width / 2);
  meshes.push(rightMesh);
  const topGeometry = new PlaneGeometry(dimensions.width, dimensions.depth);
  UVMapPlane(topGeometry, innerUVCoords[0], innerUVCoords[2], innerUVCoords[3], outerUVCoords[3]);
  const topMesh = new Mesh(topGeometry);
  topMesh.uuid = "top";
  topMesh.rotateX(-Math.PI / 2);
  topMesh.position.setY(dimensions.height / 2);
  meshes.push(topMesh);
  const bottomGeometry = new PlaneGeometry(dimensions.width, dimensions.depth);
  UVMapPlane(bottomGeometry, innerUVCoords[0], innerUVCoords[2], outerUVCoords[1], innerUVCoords[1]);
  const bottomMesh = new Mesh(bottomGeometry);
  bottomMesh.uuid = "bottom";
  bottomMesh.rotateX(Math.PI / 2);
  bottomMesh.position.setY(-dimensions.height / 2);
  meshes.push(bottomMesh);
  return meshes;
}
// Builds and UV maps the blank meshes seen on the back/interior of the canvas print
export function buildBackCanvasMeshes(dimensions, innerUVCoords, outerUVCoords) {
  const meshes = [];
  const backGeometry = new PlaneGeometry(dimensions.width, dimensions.height);
  UVMapPlane(backGeometry, innerUVCoords[0], innerUVCoords[2], innerUVCoords[1], innerUVCoords[3]);
  const backMesh = new Mesh(backGeometry);
  backMesh.uuid = "back-center";
  backMesh.rotateY(Math.PI);
  backMesh.position.setZ(dimensions.depth / 2 - 0.5);
  meshes.push(backMesh);
  const leftGeometry = new PlaneGeometry(dimensions.depth / 3, dimensions.height);
  UVMapPlane(leftGeometry, 0, outerUVCoords[0], innerUVCoords[1], innerUVCoords[3]);
  const leftMesh = new Mesh(leftGeometry);
  leftMesh.uuid = "back-left";
  leftMesh.rotateY(Math.PI);
  leftMesh.position.setX(-dimensions.width / 2 + dimensions.depth / 6);
  leftMesh.position.setZ(-dimensions.depth / 2 - 0.01);
  meshes.push(leftMesh);
  const rightGeometry = new PlaneGeometry(dimensions.depth / 3, dimensions.height);
  UVMapPlane(rightGeometry, outerUVCoords[2], 1, innerUVCoords[1], innerUVCoords[3]);
  const rightMesh = new Mesh(rightGeometry);
  rightMesh.uuid = "back-right";
  rightMesh.rotateY(Math.PI);
  rightMesh.position.setX(dimensions.width / 2 - dimensions.depth / 6);
  rightMesh.position.setZ(-dimensions.depth / 2 - 0.01);
  meshes.push(rightMesh);
  const topGeometry = new PlaneGeometry(dimensions.width, dimensions.depth / 3);
  UVMapPlane(topGeometry, innerUVCoords[2], innerUVCoords[0], 1, outerUVCoords[3]);
  const topMesh = new Mesh(topGeometry);
  topMesh.uuid = "back-top";
  topMesh.rotateY(Math.PI);
  topMesh.position.setY(dimensions.height / 2 - dimensions.depth / 6);
  topMesh.position.setZ(-dimensions.depth / 2);
  meshes.push(topMesh);
  const bottomGeometry = new PlaneGeometry(dimensions.width, dimensions.depth / 3);
  UVMapPlane(bottomGeometry, innerUVCoords[2], innerUVCoords[0], outerUVCoords[1], 0);
  const bottomMesh = new Mesh(bottomGeometry);
  bottomMesh.uuid = "back-bottom";
  bottomMesh.rotateY(Math.PI);
  bottomMesh.position.setY(-dimensions.height / 2 + dimensions.depth / 6);
  bottomMesh.position.setZ(-dimensions.depth / 2);
  meshes.push(bottomMesh);
  return meshes;
}